import { render, staticRenderFns } from "./StockSlipPayment.vue?vue&type=template&id=4ffb7bc2"
import script from "./StockSlipPayment.vue?vue&type=script&lang=js"
export * from "./StockSlipPayment.vue?vue&type=script&lang=js"
import style0 from "./StockSlipPayment.vue?vue&type=style&index=0&id=4ffb7bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports